import { addMonths, addDays, now as now_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, int32_type, record_type, array_type, bool_type, tuple_type, class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { IdNameHelper_$reflection, VesselModule_TimelineVessel_$reflection } from "../Shared/ApiDataTypes.js";
import { printf, toText, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { formatDateForUri } from "../Utils.js";

export function Period_get_ToMinMax() {
    const now = now_1();
    return (_arg) => ((_arg === "twoWeeks") ? [now, addDays(now, 14)] : ((_arg === "threeMonths") ? [now, addMonths(now, 3)] : ((_arg === "sixMonths") ? [now, addMonths(now, 6)] : [addDays(now, -14), addMonths(now, 1)])));
}

export class TimelineFilter extends Record {
    constructor(ViewWindow, CalendarRange, Vessels, Routes, Favorites, MyCompanies) {
        super();
        this.ViewWindow = ViewWindow;
        this.CalendarRange = CalendarRange;
        this.Vessels = Vessels;
        this.Routes = Routes;
        this.Favorites = Favorites;
        this.MyCompanies = MyCompanies;
    }
}

export function TimelineFilter_$reflection() {
    return record_type("Timeline.Types.TimelineFilter", [], TimelineFilter, () => [["ViewWindow", tuple_type(class_type("System.DateTime"), class_type("System.DateTime"))], ["CalendarRange", bool_type], ["Vessels", array_type(VesselModule_TimelineVessel_$reflection())], ["Routes", array_type(IdNameHelper_$reflection())], ["Favorites", bool_type], ["MyCompanies", bool_type]]);
}

export function TimelineFilter_Default() {
    return new TimelineFilter(Period_get_ToMinMax()("twoWeeks"), false, [], [], false, true);
}

export function TimelineFilter_Build(sdt, _arg, vessels, routes) {
    return new TimelineFilter(sdt, false, vessels, routes, false, true);
}

export function TimelineFilter__ToUri(this$) {
    let arg, arg_1;
    const vessels = (this$.Vessels.length === 0) ? "" : (`&vessels=${join(",", map((x) => (`${x.Id}`), this$.Vessels))}`);
    const routes = (this$.Routes.length === 0) ? "" : (`&routes=${join(",", map((x_2) => (`${x_2.Id}`), this$.Routes))}`);
    return `?${(arg = formatDateForUri(this$.ViewWindow[0]), toText(printf("start=%s"))(arg))}${(arg_1 = formatDateForUri(this$.ViewWindow[1]), toText(printf("&end=%s"))(arg_1))}${`&favorite=${this$.Favorites}`}${`&my-companies=${this$.MyCompanies}`}${vessels}${routes}`;
}

export class ActivityTemplate extends Record {
    constructor(RouteId, VesselId, Time) {
        super();
        this.RouteId = RouteId;
        this.VesselId = VesselId;
        this.Time = Time;
    }
}

export function ActivityTemplate_$reflection() {
    return record_type("Timeline.Types.ActivityTemplate", [], ActivityTemplate, () => [["RouteId", option_type(int32_type)], ["VesselId", option_type(int32_type)], ["Time", class_type("System.DateTime")]]);
}

//# sourceMappingURL=Types.js.map
